import Base from "emun.order/order-container.controller.es6";
import labels from "emun.order/_labels";
import resolve from "ioc/resolve";
import orderConfig from 'emun.order/order.config';

const sortOptions = {
  Id: "Order No.",
  "-Id": "Order No.",
  "Status,-Id": labels.status,
  "-Status,-Id": labels.status,
  "PurchaseOrder,-Id": labels.purchaseOrder,
  "-PurchaseOrder,-Id": labels.purchaseOrder,
  "VendorLabel,-Id": labels.vendorId,
  "-VendorLabel,-Id": labels.vendorId,
  "CompanyName,-Id": "Customer",
  "-CompanyName,-Id": "Customer",
  "OrderedOn,-Id": "Order Date",
  "-OrderedOn,-Id": "Order Date",
  "ShipOn,-Id": labels.shipOn,
  "-ShipOn,-Id": labels.shipOn,
  "GrandTotal,-Id": "Amount",
  "-GrandTotal,-Id": "Amount"
};

export default class OrderContainerController extends Base {
  constructor($cart) {
    super($cart);
  }

  getOrdersQueryOptions() {
    const $ctrl = this;
    var url = 'QueryOrdersJoin.json';
    var filters = [];
    if ($ctrl.customer && $ctrl.customer.id) {
        //this will be in the criteria from the main controller already
      //url = url + `?retailerId=${$ctrl.customer.id}`;
      filters.push({ groupBy: "ShipAddress", title: "Ship Address" });
    }
    orderConfig.queryOptions($ctrl).filters.forEach(function (obj) {
      filters.push(obj);
    });
    
    return Object.assign(
      super.getOrdersQueryOptions(),
      {
        url: url,
        fields: "Id,CompanyName,RetailerId,PurchaseOrder,OrderSourceLabel,VendorId,VendorLabel,GrandTotal,Balance,OrderedOn,ShipOn,ShipCity,ShipState,CurrentRepName,WritingRepName,GeneratedFrom,Status,ExpectedToClear,ReviewReason,PaymentMethodToken,PaymentMethodExpiration,PaymentMethodType,PaymentMethodLastFour,PaymentMethodName",
        filters: filters,
        sortOptions
      });
  }
}
